import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

export class VehiclesRequests {

  /* @ngInject */
  constructor(private vehiclesAPI: BringozApi, private $vehicles) {
  }

  create(vehicle) {
    const api = this.vehiclesAPI.actions.create;
    return this.$$call(api, {}, vehicle, {});
  }

  update(vehicleId, vehicleData) {
    const api = this.vehiclesAPI.actions.update;
    return this.$$call(api, {}, vehicleData, {id: vehicleId});
  }

  updateAgents(vehicleIds, agentIds, excludedAgentIds) {
    const api = this.vehiclesAPI.actions.updateAgents;
    return this.$$call(api, {vehicleIds: vehicleIds, agentIds: agentIds, excludedAgentIds: excludedAgentIds}, {}, {});
  }

  remove(vehicleId) {
    const api = this.vehiclesAPI.actions.remove;
    return this.$$call(api, {}, {}, {id: vehicleId});
  }


  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options, vehicleId?) {
    return this.$vehicles(vehicleId).$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.vehicles')
  .service('vehiclesRequests', VehiclesRequests);
